import React from "react";

const TronIcon = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      fill="#EF0027"
    />
    <path
      d="M21.932 9.91284L7.5 7.25684L15.095 26.3688L25.678 13.4748L21.932 9.91284ZM21.7 11.0828L23.908 13.1818L17.87 14.2748L21.7 11.0828ZM16.558 14.0558L10.194 8.77784L20.596 10.6918L16.558 14.0558ZM16.105 14.9898L15.067 23.5698L9.472 9.48684L16.105 14.9888V14.9898ZM17.065 15.4448L23.752 14.2348L16.082 23.5778L17.065 15.4448Z"
      fill="white"
    />
  </svg>
);

export default TronIcon;
